export const fullWidthComponents = ['Carousel', 'Faq']
